import { FC, useState } from 'react'
import styled from 'styled-components'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import Carnet from '../../assets/carnet-down.svg'
import {
  TextWidth,
  TextWidthExtended,
  ContentWidth,
} from '@ta-interaktiv/react-disco-grid'

export const InfoboxComponent: FC<{
  title?: string
  dwSourceUrl: string[]
  iFrameStyleHeight?: string
  defaultModeOpen?: boolean | string
  trackEvent?: MicroFrontendProps['trackEvent']
  colorMode?: 'light' | 'dark' | undefined
}> = ({
  title,
  dwSourceUrl,
  iFrameStyleHeight,
  defaultModeOpen,
  trackEvent,
  colorMode,
}) => {
  let defaultModeOpenString = defaultModeOpen // or "false"
  let defaultModeOpenBoolean =
    typeof defaultModeOpenString === 'string'
      ? defaultModeOpenString.toLowerCase() === 'true'
      : !!defaultModeOpenString // double not to convert boolean to boolean

  const [isOpen, setOpen] = useState(defaultModeOpenBoolean)
  return (
    <TextWidth>
      <Infobox className={'infobox ' + (isOpen ? 'open ' : '') + colorMode}>
        <div className='wrapper'>
          {/* <div className='qline' /> */}
          <ShowMoreButton
            className='title'
            onClick={() => {
              trackEvent &&
                trackEvent('Interactions', {
                  interactive_event_label: isOpen
                    ? 'infobox_closed'
                    : 'infobox_opened',
                  interactive_event_action: 'click',
                })
              setOpen(!isOpen)
            }}
          >
            <h4>{title}</h4>
            <img
              src={Carnet}
              className={'icon ' + (isOpen ? 'open' : '')}
              alt='icon carnet'
            ></img>
          </ShowMoreButton>
        </div>
        <div className={'contentwrapper'}>
          {dwSourceUrl &&
            dwSourceUrl.map((itemSourceUrl: string, index: number) => {
              if (
                !itemSourceUrl.includes('datawrapper.dwcdn.net') &&
                !itemSourceUrl.includes('app.datawrapper.de/chart')
              ) {
                itemSourceUrl = 'https://datawrapper.dwcdn.net/' + itemSourceUrl
                if (itemSourceUrl[itemSourceUrl.length - 1] !== '/') {
                  itemSourceUrl += '/'
                }
              }
              return (
                <AutofitIFrame
                  key={index}
                  src={itemSourceUrl + '?transparent=true' + '&dark=' + String(colorMode === 'dark')}
                  style={{
                    height: iFrameStyleHeight && iFrameStyleHeight,
                    minHeight: iFrameStyleHeight && iFrameStyleHeight,
                  }}
                />
              )
            })}
          {/* {paragraphs &&
            paragraphs.map((item, index) => {
              return <p dangerouslySetInnerHTML={{ __html: item }}></p>
            })} */}
        </div>
      </Infobox>
    </TextWidth>
  )
}

const Infobox = styled.aside`
  font-family: var(--font-sans-serif);
  color: var(--text-color);
  font-size: 1.8rem;
  line-height: 2.4rem;
  padding: 2.5rem 3rem;
  background-color: var(--gray-6);
  max-width: 494px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 6rem;
  @media only screen and (max-width: 711px) {
    margin-bottom: 4rem;
  }

  /* :hover {
    background-color: var(--gray-5);
  } */
  &.dark {
    background-color: rgb(38, 38, 38);
    img {
      filter: invert(1) brightness(200%);
    }
  }
  /* &.dark:hover {
    background-color: rgb(32, 32, 32);
  } */
  h4 {
    margin: 0;
    color: var(--text-color);
    text-align: left;
  }
  /* max-height: 0;
  transition: max-height 0.5s ease-in-out, opacity 0.25s ease-in,
    padding-top 0.25s ease-in; */
  .contentwrapper {
    display: none;
    overflow: hidden;

    .legendContainer {
      display: flex;
      flex-direction: column;
    }
    .row {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      padding: 0.1em 0;
    }
    img.legend {
      width: 24px;
      height: 24px;
      margin-right: 1em;
    }
  }

  &.open {
    height: auto;
    margin-bottom: 3rem;
    /* max-height: 1000px; */
    .contentwrapper {
      display: block;

      padding-top: 3.5rem;
      overflow: visible;
      opacity: 1;

      font-size: 1.6rem;
      font-family: var(--font-sans-serif);
      line-height: 2.3rem;
    }
  }
`

const ShowMoreButton = styled.button`
  font-size: 1.8rem;
  font-family: var(--font-sans-serif);
  line-height: 2.4rem;
  transition: 0.2s;
  background: transparent;
  margin: 0;
  padding: 0;
  width: 100%;
  border: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  img.icon {
    width: 16px;
    height: 16px;
    margin-left: 1.5em;
    transition: transform 0.3s ease;
    &.open {
      transition: transform 0.3s ease;
      transform: rotate(180deg) translateY(10%);
    }
  }

  .carnet {
    width: 20px;
    height: 20px;
    display: inline-block;
    background-image: url(Carnet);
    background-repeat: no-repeat;
    background-size: 22px;
    background-position: top;
  }
`
